import './VenueCheckIns.scss';

function VenueCheckIns({ specVenue }) {

    if (specVenue.checkIns === 0) {
        return (
            <section className='no-checks'>
                <p className='no-checks__text'>
                    There are no check-ins for this venue yet.
                </p>
            </section>
        )
    }
    else {
        return (
            <section className='checks'>
                <p className='checks__text'>
                    Check-in display coming soon.
                </p>
            </section>
        )
    }
}

export default VenueCheckIns;